import type { RouteObject } from 'react-router';
import { ReportsPage } from './ReportsPage';

/** 经营报表（path 相对 /v2）。期间、周转天数、口径、周转筛选都在 URL 查询参数里 */
export const routes: RouteObject[] = [{ path: 'reports', element: <ReportsPage /> }];
